var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitySm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.896,
    height: 16.293,
    viewBox: "0 0 15.896 16.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#19a4bc",
    d: "M10.364,8.207l2.851-4.924,1.378,4.924L13.215,13.13,10.364,8.207Zm-1.39.8,2.852,4.923L6.859,12.657,3.272,9.007Zm2.851-6.523L8.974,7.407h-5.7L6.859,3.756ZM15.9,6.532,14.156.06,7.664,1.794,6.7,3.484,4.752,3.47,0,8.208l4.752,4.736h0L6.7,12.929l.962,1.69,6.492,1.734L15.9,9.883l-.988-1.676L15.9,6.532Z",
    transform: "translate(0 -0.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitySm);
export default __webpack_public_path__ + "static/media/unity-sm.30885711.svg";
export { ForwardRef as ReactComponent };